module.exports = __webpack_public_path__ + "img/09.b0fd871a.png";